<template>
    <b-modal v-model="isModalVisible" :title="modalTitle" hide-footer no-close-on-backdrop :size="modalSize">
        <div class="d-flex justify-content-end mb-2" v-if="isAdmin">
            <div class="d-flex align-items-center">
                <span class="mr-2 small">Admin mode</span>
                <b-form-checkbox
                    switch
                    v-model="isAdminForm"
                    @change="handleAdminToggle">
                </b-form-checkbox>
            </div>
        </div>

        <PostForm
            :status="status"
            :section="section"
            :category="category"
            :categories="categories"
            :is-admin="isAdmin"
            :is-admin-form="isAdminForm"
            :statuses="statuses"
            :sections="sections"
            :tab-type="tabType"
            :is-modal="true"
            @post-added="handlePostAdded"
            @cancel="isModalVisible = false"
            @close-modal="closeModal"
        />
    </b-modal>
</template>

<script>
import PostForm from './PostForm.vue';
import NotificationPop
    from "../mixins/NotificationPop";
import {
    mapState
} from "vuex";

export default {
    components: {
        PostForm
    },
    mixins: [NotificationPop],
    props: {
        status: Number,
        section: Number,
        category: Number,
        categories: Array,
        isAdmin: {
            type: Boolean,
            required: true
        },
        isAdminForm: {
            type: Boolean,
            default: false
        },
        statuses: {
            type: Array,
            required: false
        },
        sections: {
            type: Array,
            required: false
        },
        tabType: {
            type: String,
            default: ''
        },
        modalTitle: {
            type: String,
            default: 'Add post'
        },
    },
    computed: {
        modalSize() {
            return this.isAdminForm ? 'xl' : 'md';
        }
    },
    data() {
        return {
            isModalVisible: false,
            post: null
        };
    },
    methods: {
        handlePostAdded(post) {
            this.$emit('post-added', post);
            this.post = post
            if(this.isAdminForm) {
                this.closeModal()
            }
        },
        closeModal() {
            this.isModalVisible = false;
        },
        handleAdminToggle(val) {
            // Reset form when switching modes
            this.backendErrors = [];
            this.duplicates = [];
            this.displayAttachment = false;
            this.initializeNewPost();
            this.$emit('update:isAdminForm', val);
        },
    }
};
</script>
